/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { UomDetailsDto } from '@gh/builder-shared-data';

export type UomDetails = UomDetailsDto;
export const UOM_DETAILS_DEFAULT = {
  format: '8.2',
  roundUp: 0.01,
};
